import { render, staticRenderFns } from "./CurrentAmounts.vue?vue&type=template&id=2138378a&"
import script from "./CurrentAmounts.vue?vue&type=script&lang=js&"
export * from "./CurrentAmounts.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAmounts.vue?vue&type=style&index=0&id=2138378a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports